var React = require('react');

function LinkedIn (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.11877 3.77127H2.09337C0.823377 3.77127 0 2.94039 0 1.88717C0 0.813472 0.847719 0 2.14311 0C3.43744 0 4.2333 0.811424 4.2587 1.8841C4.2587 2.93731 3.43744 3.77127 2.11877 3.77127ZM18 16H14.0218V10.3754C14.0218 8.90312 13.3995 7.89806 12.031 7.89806C10.9844 7.89806 10.4023 8.57629 10.1313 9.22994C10.0419 9.43651 10.0435 9.71457 10.0452 10.0012V10.0012C10.0454 10.0401 10.0456 10.0791 10.0456 10.1182V16H6.10442C6.10442 16 6.15522 6.0365 6.10442 5.13082H10.0456V6.83665C10.2785 6.0908 11.5379 5.02632 13.5476 5.02632C16.041 5.02632 18 6.58974 18 9.95633V16ZM3.96237 5.13082H0.454022V16H3.96237V5.13082Z"}));
}

LinkedIn.defaultProps = {"width":"18","height":"16","viewBox":"0 0 18 16"};

module.exports = LinkedIn;

LinkedIn.default = LinkedIn;
